<div class="table-responsive" [ngClass]="customClass ? customClass : 'scrollable-table'">
    <table
        class="table table-condensed"
        [ngClass]="{ 'disable-hover': disableHover, 'table-active': rowSelection }"
        infiniteScroll
        [fromRoot]="true"
        [infiniteScrollContainer]="(customClass ? '.' + customClass : '.scrollable-table') + ' tbody'"
        (scrolled)="onScroll()"
    >
        <thead>
        <tr #thead class="unselectable">
            <ng-content select="[header]"></ng-content>
        </tr>
        </thead>
        <tbody #tbody>
            <div #tbodyContainer class="tbody-container unselectable" [appTableKeyBind]="keyboardNavigation">
                <ng-content select="[body]"></ng-content>
                @if (loadingItems) {
                    <tr class="table-spinner absolute-centering"></tr>
                }
            </div>
        </tbody>
        <app-spinner
            [overlay]="true"
            [height]="getLoadingScreenHeight()"
            [visible]="loadingTable"
            [infoText]="loadingTableText"
        ></app-spinner>
    </table>
</div>
